import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { retry, catchError, timeout } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { AlertService } from '@app/_services';
import { OwnerStmt } from './owner-stmt';
import { SharedService } from './../_shared/shared.service';

@Injectable({ providedIn: 'root' })
export class OwnerStmtService {

	statuses: any = [
		{ value: '1', name: 'draft' },
		{ value: '2', name: 'for review' },
		{ value: '3', name: 'for review2' },
		{ value: '4', name: 'for review3' },
		{ value: '5', name: 'for review4' },
		{ value: '6', name: 'for review5' },
		{ value: '7', name: 'for review6' },
		{ value: '8', name: 'for approved' },
		{ value: '9', name: 'for published' },
	];

	expenseCategories: any = [
		{ value: 1, name: 'Maintenance' },
		{ value: 2, name: 'Housekeeping' },
		{ value: 3, name: 'Onboarding' },
		{ value: 4, name: 'Inspection' },
		{ value: 6, name: 'Tax' },
		{ value: 5, name: 'Other' }
	];


	constructor
		(
			private http: HttpClient,
			private alertService: AlertService,
			private sharedService: SharedService
		) { }

	urlEndpoint = 'owner-stmts';

	add(ownerStmt: OwnerStmt): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(ownerStmt));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, ownerStmt);
	}

	update(ownerStmt: OwnerStmt): Observable<ApiResponse> {
		return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, ownerStmt);
	}

	delete(developmentId: number): Observable<ApiResponse> {
		return this.http.delete<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${developmentId}`);
	}

	findAll(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	findByFilter(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any): Observable<ApiResponse> {
		let params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		console.log('posting... ' + JSON.stringify(filters));
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, { params: params }).pipe(retry({ count: 2, delay: 1500 }));

	}

	findById(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	findStmtById(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/owner-stmts-pdf-preview/${id}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	getPdfAsBlob(ownerStmtId: number): any {
		return this.http.get(`${environment.apiUrl}/owner-stmts/${ownerStmtId}/pdf`, {
			observe: 'response',
			responseType: 'blob'
		}).pipe(timeout(30000));
	}

	audit(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}/audit`).pipe(retry({ count: 2, delay: 1500 }));
	}

	reconcile(startDate: string, endDate: string): Observable<ApiResponse> {
		let payload = {
			startDate: startDate,
			endDate: endDate
		};
		return this.http.post<ApiResponse>(`${environment.apiUrl}/owner-stmt/reconcile`, payload);
	}

	sendStatementEmail(ownerStmtId: number, htmlContent: string): Observable<ApiResponse> {
		const payload = {
			ownerStmtId: ownerStmtId,
			htmlContent: htmlContent
		};
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/send-email`, payload);
	}


	prepareParamsFromPrimeNgDataTable(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any) {
		try {
			console.log(
				'  |  page:' + page
				+ '  |  size:' + size
				+ '  |  sortBy:' + sortBy
				+ '  |  sortOrder:' + sortOrder
				+ '  |  multiSortMeta:' + JSON.stringify(multiSortMeta)
				+ '  |  globalFilter:' + globalFilter
				+ '  |  filters:' + JSON.stringify(filters)
			);

			let params = new HttpParams();

			if (!isNaN(page)) { params = params.append('page', page); }
			if (!isNaN(size)) { params = params.append('size', size); }
			if (sortBy) { params = params.append('sort', sortBy + ',' + (sortOrder === 1 ? 'asc' : 'desc')); }
			if (multiSortMeta) {
				// if sortMode="multiple" in primeng table then multiSortMeta is used for ALL sorting (even just one column.)
				// Otherwise, single sorting is used above.
				// event.multiSortMeta:[{"field":"lastName","order":1},{"field":"firstName","order":1}]
				for (let i = 0; i < multiSortMeta.length; i++) {
					let json = JSON.parse(JSON.stringify(multiSortMeta[i]));
					params = params.append('sort', json.field + ',' + (json.order === 1 ? 'asc' : 'desc'));
				}
			}
			// globalFilter works, but did not implemnt in Spring but not hard to write custom findAll and specify certain columns to look.
			if (globalFilter) { params = params.append('filter', globalFilter); }

			// multiselect or input or whatever... these work slick.
			if (filters) {
				// key:status val:{"value":["A"],"matchMode":"in"}
				for (let i = 0, keys = Object.keys(filters), ii = keys.length; i < ii; i++) {
					console.log('key:' + keys[i] + ' val:' + JSON.stringify(filters[keys[i]]));
					params = params.append(keys[i], filters[keys[i]].value);
				}
			}
			return params;
		} catch (error) {
			console.log('prepareParamsFromPrimeNgDataTable()' + error);
		}
	}
}
